"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCropForUserPhotoLayerInPrintableInProject;
const UserPhotoLayer_1 = require("../../models/layers/UserPhotoLayer");
const either_1 = require("../../types/either");
const printables_1 = require("../printables");
const getCropForUserPhotoLayer_1 = __importDefault(require("./getCropForUserPhotoLayer"));
const userPhotoLayerHasMaxCrop_1 = __importDefault(require("./userPhotoLayerHasMaxCrop"));
function getCropForUserPhotoLayerInPrintableInProject(printable, layerId, workspaceRotatedForPrintable, galleryImage) {
  var _a, _b, _c, _d, _e, _f, _g;
  const layer = (0, printables_1.findLayerInPrintable)(printable, layerId);
  if (!layer) {
    return (0, either_1.left)(new Error('Could not find target layer to add image to'));
  }
  const galleryId = galleryImage ? galleryImage.galleryId : (_a = layer.userData) === null || _a === void 0 ? void 0 : _a.galleryId;
  const galleryImageId = galleryImage ? galleryImage.id : (_b = layer.userData) === null || _b === void 0 ? void 0 : _b.galleryImageId;
  const imageSize = {
    width: galleryImage ? galleryImage.metadata.width : ((_c = layer.userData) === null || _c === void 0 ? void 0 : _c.imageData.width) || 0,
    height: galleryImage ? galleryImage.metadata.height : ((_d = layer.userData) === null || _d === void 0 ? void 0 : _d.imageData.height) || 0
  };
  if (!galleryId || !galleryImageId || !imageSize.width || !imageSize.height) {
    return (0, either_1.left)(new Error('Not enough information provided to calculate crop'));
  }
  if (!layer.userData || (0, UserPhotoLayer_1.isDefaultModifications)(layer.userData.modifications) || (0, userPhotoLayerHasMaxCrop_1.default)(layer.userData) || (galleryImage === null || galleryImage === void 0 ? void 0 : galleryImage.metadata.width) !== ((_e = layer.userData) === null || _e === void 0 ? void 0 : _e.imageData.width) || (galleryImage === null || galleryImage === void 0 ? void 0 : galleryImage.metadata.height) !== ((_f = layer.userData) === null || _f === void 0 ? void 0 : _f.imageData.height)) {
    return (0, either_1.right)((0, getCropForUserPhotoLayer_1.default)(printable.surface, layer, galleryId, galleryImageId, imageSize, workspaceRotatedForPrintable, (_g = layer.userData) === null || _g === void 0 ? void 0 : _g.modifications));
  }
  return (0, either_1.right)(layer.userData);
}